export const MONITOR_PARAMETER_TYPE = {
    DIRECT: 1,  // 直接参数，是指传感器能测出的数字量和直接物理量，例如频率、应变
    INDIRECT: 2,  // 间接参数，是需要由直接参数或间接参数计算出来的
}

export function getMonitorParameterTypeName(value: number) {
    if (!value) return ''
    if (value === MONITOR_PARAMETER_TYPE.DIRECT) {
        return "直接参数"
    } else if (value === MONITOR_PARAMETER_TYPE.INDIRECT) {
        return "间接参数"
    }
    return ''
}

export const MONITOR_PARAMETER_TYPE_LIST = [
    { value: 1, label: '直接参数'},
    { value: 2, label: '间接参数'},
]